import { render } from "./ExternalDesign.vue?vue&type=template&id=9cac202e&scoped=true"
import script from "./ExternalDesign.vue?vue&type=script&lang=js"
export * from "./ExternalDesign.vue?vue&type=script&lang=js"

import "./ExternalDesign.vue?vue&type=style&index=0&id=9cac202e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cac202e"]])

export default __exports__